var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Button',{staticClass:"u-b1",attrs:{"data-test":"resend-preorder-order-button","icon":"reload","type":"default"},on:{"click":_vm.resendOrder}},[_vm._v(" "+_vm._s(_vm.$t('Resend order'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }